var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[[_c('list-group',{attrs:{"title":'マイルを貯める'}},[_c('list-item',{attrs:{"spanText":'Q. ',"text":'マイルを貯める方法',"urlName":'FeaturesDailyMission'}})],1)]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0247f466","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpCategory41.vue
// module id = PXHs
// module chunks = 0